import {ChangeDetectionStrategy, Component, input, Signal} from '@angular/core';

import {TemplateBolderPipe} from './template-bolder.pipe';

@Component({
	selector: 'text-bolder',
	imports: [TemplateBolderPipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: `
		::ng-deep .text-bolder {
			@apply font-bold underline bg-yellow-200;
		}
	`,
	template: ` <span [innerHTML]="text() | BoldText: term()() : class()"></span> `,
})
export class TextBolderComponent {
	/* ------------------------------------------------  Inputs ------------------------------------------------ */
	readonly text = input.required<string>();
	readonly term = input.required<Signal<string>>();
	readonly class = input('text-bolder');

	/* ----------------------------------------------  Constructor ---------------------------------------------- */
	constructor() {}
}
